import ecbrApi from '../services/ecbrApi'
import { extractErrorMessage } from './extractErrorMessage'

export const isAvailableCoupon = async (coupon, setError) => {
  try {
    const { data } = await ecbrApi.coupons.existsByCode(coupon)
    setError?.('')
    return !data?.success
  } catch (err) {
    setError?.(extractErrorMessage(err))
    return undefined
  }
}
